module.exports = __webpack_public_path__ + "static/media/logo.080454c2.png";